import {environment} from "environments";

class AddBatchingRuleForm {
  constructor(Batching, GroupsService) {
    Object.assign(this, {
      Batching,
      GroupsService,
      services: [],
      cachedProducts: {},
      products: [],
      rules: {},
      rulePlaceholder: null,
      savingChanges: false,
      newRule: {
        services: [],
        products: [],
        rule: '',
        params: '',
      },
      editModal: false,
      disableRuleSelection: false
    });
  }

  $onInit() {
    this.Batching.getBatchRuleTypes()
      .then((rules) => {
        this.rules = rules;
    });

  }

  $onChanges(changeObj) {
    if (changeObj.rulePlaceholder) {
      if (this.services.length) {
        this.resetRule();
        const copyRule = changeObj.rulePlaceholder.currentValue;
        const foundService = this.services
          .find(service => copyRule.service === service.category_code);
        foundService.selected = true;
        if (copyRule.product) {
          this.serviceSelected(foundService, [copyRule.product]);
        }
        this.newRule.rule = copyRule.rule;
        this.newRule.params = copyRule.params;
      }
    }
    if (changeObj.row) {

      (async () => {
        this.services = await this.Batching.getCategories();
        if (this.row?.service || this.row?.product) {
          this.editModal = true;
          this.services.forEach((service) => {
            if (service.category_code === this.row.service) {
              service.selected = true;
              this.serviceSelected(service, [this.row.product]);
            }
          });
        }
        if (this.row?.rule || this.row?.params) {
          this.disableRuleSelection = true;
          this.newRule.rule = this.row.rule;
          this.newRule.params = this.row.params;
        }
      })();
    }
  }

  addProductsToMultiSelectList(products, service, selectedProducts = []) {
    const productSelectList = products.map(product => ({
      label: `${product.title} ${product.subtitle}`,
      id: product.id,
      category_code: service.category_code,
      code: product.code,
      selected: selectedProducts
        .some(defaultSelectedProduct => product.code === defaultSelectedProduct),
    }));
    this.products = [
      { label: service.name, category_code: service.category_code, msGroup: true },
      ...productSelectList,
      { category_code: service.category_code, msGroup: false },
      ...this.products,
    ];
  }

  serviceSelected(service, selectedProducts) {
    if (service.selected) {
      if (!this.cachedProducts[service.category_code]) {
        this.GroupsService.getProductsByServiceCode(service.category_code)
          .then(({ data: products }) => {
            this.cachedProducts[service.category_code] = products;
            this.addProductsToMultiSelectList(products, service, selectedProducts);
          });
      } else {
        this.addProductsToMultiSelectList(
          this.cachedProducts[service.category_code], service, selectedProducts);
      }
    } else {
      this.products = this.products
        .filter(row => row.category_code !== service.category_code);
    }
  }

  ruleSelected() {
    this.newRule.params = this.rules[this.newRule.rule].params_hint;
  }

  resetRule() {
    this.newRule = {
      services: [],
      products: [],
      rule: '',
      params: '',
    };
    this.services.forEach((service) => {
      service.selected = false;
    });
    this.products = [];
  }

  saveRule(rule) {
    rule.params = this.newRule?.params || null;
    rule.editable.params = this.newRule?.params || null;
    this.parent.saveBatchingRule(rule);
  }

  deleteRule(rule) {
    this.parent.deleteBatchingRule(rule);
  }

  saveChanges() {
    const rules = [];
    this.savingChanges = true;
    this.newRule.services.forEach((service) => {
      const service_products = this.newRule.products
        .filter(product => product.category_code === service.category_code);
      if (service_products.length) {
        service_products.forEach((product) => {
          rules.push({
            service: service.category_code,
            product: product.code,
            rule: this.newRule.rule,
            params: this.newRule.params,
          });
        });
      } else {
        rules.push({
          service: service.category_code,
          product: null,
          rule: this.newRule.rule,
          params: this.newRule.params,
        });
      }
    });
    const rulePostRequests = [];
    rules.forEach((rule) => {
      rulePostRequests.push(
        this.Batching.createBatchRule(rule)
          .then(({ data: newRule }) => {
            rule.id = newRule.id;
          })
      );
    });
    Promise.all(rulePostRequests)
      .then(() => {
        this.resetRule();
        this.onSave({ rules });
      })
      .finally(() => {
        this.savingChanges = false;
      });
  }

  resizeTextArea(event) {
    event.target.style.height = 'auto';
    event.target.style.height = event.target.scrollHeight + 'px';
  }

}

AddBatchingRuleForm.$inject = ['Batching', 'GroupsService'];
angular.module("pims").component('addBatchingRuleForm', {
  templateUrl: 'app/views/settings/batching-rules/add-batching-rule-form/add-batching-rule-form.component.html',
  controller: AddBatchingRuleForm,
  controllerAs: 'vm',
  bindings: {
    onSave: '&',
    rulePlaceholder: '<',
    row: '<',
    parent: '=',
  },
});
